import { useDialog } from "@shared/features/dialog/useDialog";
import { ProgramDialogTypes } from "@platform/types/dashboard.types";
import { ProgramFriendInviteDeletion } from "../ProgramFriendInviteDeletion/ProgramFriendInviteDeletion";
import { ProgramFriendInviteFormContainer } from "../ProgramFriendInviteForm/ProgramFriendInviteFormContainer";
import { ProgramPhasesQuizFormContainer } from "../ProgramPhasesQuizForm/ProgramPhasesQuizFormContainer";
import { ProgramScheduleFormContainer } from "../ProgramScheduleForm/ProgramScheduleFormContainer";
import { ProgramCircleParticipantsContainer } from "../ProgramCircle/ProgramCircleParticipantsContainer";
import { ProgramAddCalendarEventsContainer } from "../ProgramAddCalendarEvents/ProgramAddCalendarEventsContainer";
import { ProgramMeetingInformationContainer } from "../ProgramMeetingInformation/ProgramMeetingInformationContainer";

export function ProgramDialogs() {
  const { activeDialog } = useDialog();

  if (
    ![
      "invitationSend",
      "invitationDelete",
      "quiz",
      "scheduling",
      "circle",
      "meetingInformation",
      "addCalendarEvents",
    ].includes(activeDialog || "")
  ) {
    return null;
  }

  switch (activeDialog as ProgramDialogTypes) {
    case "invitationSend":
      return <ProgramFriendInviteFormContainer />;
    case "invitationDelete":
      return <ProgramFriendInviteDeletion />;
    case "quiz":
      return <ProgramPhasesQuizFormContainer />;
    case "scheduling":
      return <ProgramScheduleFormContainer />;
    case "circle":
      return <ProgramCircleParticipantsContainer />;
    case "addCalendarEvents":
      return <ProgramAddCalendarEventsContainer />;
    case "meetingInformation":
      return <ProgramMeetingInformationContainer />;
    default:
      return null;
  }
}

export default ProgramDialogs;
